import React from "react";
import styled from "styled-components";
import { Fade } from "react-awesome-reveal";

export default function TermsConditions() {
  return (
    <PageWrapper>
      <Container>
        <Fade cascade damping={0.1} triggerOnce>
          <HeaderSection>
            <Title>Terms & Conditions for MikeConnect Media</Title>
            <LastUpdated>Effective immediately upon posting</LastUpdated>
          </HeaderSection>

          <ContentCard>
            <Section>
              <Text>
                Welcome to MikeConnect Media Network (https://mikeconnect.com). These Terms and Conditions ("Terms") govern your access to and use of this website. By accessing or using MikeConnect.com, you agree to be bound by these Terms. If you do not agree with any part of these Terms, please discontinue use of the website.
              </Text>
            </Section>

            <Section>
              <SectionHeading>1. About Mike-Connect</SectionHeading>
              <Text>
                Mike-Connect is a website where we guide, mentor, teach and encourage personal development through strategic life-changing sessions. But beyond that is a blog and informational website that publishes articles, insights, and digital content across various topics for educational and informational purposes. The website may display advertisements, including but not limited to Google AdSense, in the present or future.
              </Text>
            </Section>

            <Section>
              <SectionHeading>2. Acceptance of Terms</SectionHeading>
              <Text>
                By accessing this website, you confirm that:
              </Text>
              <List>
                <ListItem>You are at least 18 years old or have parental/guardian consent.</ListItem>
                <ListItem>You will use the website in compliance with these Terms, applicable laws, and regulations.</ListItem>
                <ListItem>You accept that these Terms may be updated from time to time.</ListItem>
              </List>
            </Section>

            <Section>
              <SectionHeading>3. Intellectual Property Rights</SectionHeading>
              <Text>
                Unless otherwise stated, all content on MikeConnect—including articles, text, graphics, logos, images, videos, and design elements—is the intellectual property of MikeConnect and/or its content contributors.
              </Text>
              <Text>Therefore you may:</Text>
              <List>
                <ListItem>View and read content for personal, non-commercial use.</ListItem>
                <ListItem>Share links to articles with proper attribution.</ListItem>
              </List>
              <Text>You may not:</Text>
              <List>
                <ListItem>Republish, reproduce, duplicate, or redistribute content without prior written permission.</ListItem>
                <ListItem>Use content for commercial purposes without authorization.</ListItem>
              </List>
            </Section>

            <Section>
              <SectionHeading>4. User Conduct</SectionHeading>
              <Text>
                When using MikeConnect, you agree not to:
              </Text>
              <List>
                <ListItem>Post or transmit harmful, defamatory, abusive, or unlawful content.</ListItem>
                <ListItem>Attempt to hack, disrupt, or damage the website or its services.</ListItem>
                <ListItem>Use the website for spam, phishing, or fraudulent activities.</ListItem>
                <ListItem>Violate any applicable local, national, or international laws.</ListItem>
              </List>
              <Text>
                We reserve the right to restrict or terminate access for users who violate these Terms.
              </Text>
            </Section>

            <Section>
              <SectionHeading>5. Comments and User-Generated Content</SectionHeading>
              <Text>
                Users may be allowed to post comments or other content on MikeConnect.
              </Text>
              <Text>By submitting content, you:</Text>
              <List>
                <ListItem>Grant MikeConnect a non-exclusive, royalty-free license to use, display, and distribute such content.</ListItem>
                <ListItem>Confirm that your content does not infringe on third-party rights.</ListItem>
              </List>
              <Text>MikeConnect reserves the right to moderate, edit, or remove comments that are inappropriate, offensive, or violate these Terms.</Text>
            </Section>

            <Section>
              <SectionHeading>6. Advertising and Google AdSense</SectionHeading>
              <Text>
                MikeConnect may display advertisements from third-party advertising networks, including Google AdSense.
              </Text>
              <List>
                <ListItem>Third-party vendors may use cookies, web beacons, or similar technologies to serve ads based on users’ visits to this and other websites.</ListItem>
                <ListItem>Google’s use of advertising cookies enables it and its partners to serve ads based on users’ browsing behavior.</ListItem>
              </List>
              <Text>
                Users may opt out of personalized advertising by visiting Google’s Ads Settings. MikeConnect does not control the content of third-party advertisements and is not responsible for products or services advertised.
              </Text>
            </Section>

            <Section>
              <SectionHeading>7. Cookies and Tracking Technologies</SectionHeading>
              <Text>
                MikeConnect uses cookies to:
              </Text>
              <List>
                <ListItem>Improve user experience.</ListItem>
                <ListItem>Analyze website traffic and performance.</ListItem>
                <ListItem>Support advertising and analytics services.</ListItem>
              </List>
              <Text>
                By using this website, you consent to the use of cookies in accordance with our Privacy Policy.
              </Text>
            </Section>

            <Section>
              <SectionHeading>8. Disclaimer of Content</SectionHeading>
              <List>
                <ListItem>We make no guarantees regarding the accuracy, completeness, or reliability of any information.</ListItem>
                <ListItem>Content should not be considered professional, legal, medical, or financial advice.</ListItem>
                <ListItem>Users act on information from this website at their own risk.</ListItem>
              </List>
            </Section>

            <Section>
              <SectionHeading>9. Limitation of Liability</SectionHeading>
              <Text>
                To the fullest extent permitted by law, MikeConnect shall not be liable for:
              </Text>
              <List>
                <ListItem>Any direct, indirect, incidental, or consequential damages arising from your use of the website.</ListItem>
                <ListItem>Losses caused by reliance on website content.</ListItem>
                <ListItem>Issues resulting from third-party links or advertisements.</ListItem>
              </List>
            </Section>

            <Section>
              <SectionHeading>10. External Links</SectionHeading>
              <Text>
                MikeConnect may contain links to external websites for reference or convenience.
              </Text>
              <List>
                <ListItem>We do not control or endorse the content of third-party websites.</ListItem>
                <ListItem>We are not responsible for the privacy practices, policies, or content of external sites.</ListItem>
              </List>
              <Text>Users access third-party websites at their own risk.</Text>
            </Section>

            <Section>
              <SectionHeading>11. Privacy</SectionHeading>
              <Text>
                Your use of MikeConnect is also governed by our Privacy Policy, which explains how we collect, use, and protect your personal data.
              </Text>
            </Section>

            <Section>
              <SectionHeading>12. Termination</SectionHeading>
              <Text>
                We reserve the right to:
              </Text>
              <List>
                <ListItem>Suspend or terminate access to the website without prior notice.</ListItem>
                <ListItem>Remove any content that violates these Terms or applicable laws.</ListItem>
              </List>
            </Section>

            <Section>
              <SectionHeading>13. Governing Law</SectionHeading>
              <Text>
                These Terms and Conditions shall be governed by and interpreted in accordance with the laws of the Federal Republic of Nigeria, without regard to conflict of law principles.
              </Text>
            </Section>

            <Section>
              <SectionHeading>14. Changes to These Terms</SectionHeading>
              <Text>
                MikeConnect may revise these Terms at any time. Updated versions will be posted on this page with a revised effective date. Continued use of the website constitutes acceptance of the updated Terms.
              </Text>
            </Section>

            <Section>
              <SectionHeading>15. Contact Information</SectionHeading>
              <Text>
                If you have questions or concerns regarding these Terms and Conditions, please contact us via:
              </Text>
              <List>
                <ListItem>Website: https://mikeconnect.com</ListItem>
                <ListItem>Email: contact@mikeconnect.com or admin@nikeconnect.com</ListItem>
              </List>
              <Text>
                By using MikeConnect, you acknowledge that you have read, understood, and agreed to these Terms and Conditions.
              </Text>
            </Section>
          </ContentCard>
        </Fade>
      </Container>
    </PageWrapper>
  );
}

/* ===================== STYLES ===================== */

const PageWrapper = styled.div`
  background-color: #f8f9fa;
  min-height: 100vh;
  padding: 80px 20px;

  @media (max-width: 768px) {
    padding: 40px 15px;
  }
`;

const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

const HeaderSection = styled.div`
  text-align: center;
  margin-bottom: 50px;
`;

const Title = styled.h1`
  font-size: 42px;
  font-weight: 800;
  margin-bottom: 15px;
  background: linear-gradient(90deg, green, green);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

const LastUpdated = styled.p`
  font-size: 14px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const ContentCard = styled.div`
  background: white;
  padding: 60px;
  border-radius: 24px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.05);
  line-height: 1.8;

  @media (max-width: 768px) {
    padding: 30px 20px;
  }
`;

const Section = styled.section`
  margin-bottom: 40px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const SectionHeading = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin-bottom: 15px;
  position: relative;
  display: inline-block;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -4px;
    width: 40px;
    height: 3px;
    background: green;
    border-radius: 2px;
  }
`;

const Text = styled.p`
  font-size: 16px;
  color: #555;
  margin-bottom: 20px;
`;

const List = styled.ul`
  margin-left: 20px;
  margin-bottom: 20px;
`;

const ListItem = styled.li`
  color: #555;
  margin-bottom: 10px;
  font-size: 16px;
`;
